const STAT_COLORS = {
  awareness: "#3B82F6",
  trust: "#A855F7",
  leads: "#F59E0B",
  energy: "#EF4444",
  systems: "#06B6D4",
};

const STAT_ICONS = {
  awareness: "📣",
  trust: "🛡",
  leads: "🎯",
  energy: "⚡",
  systems: "⚙",
};

export default function StatBar({ label, value, color, statKey, compact = false }) {
  const v = Math.max(0, Math.min(100, value));
  const fillColor = color || STAT_COLORS[statKey] || "#F26522";
  return (
    <div data-testid={`stat-bar-${statKey || label?.toLowerCase()}`} className="w-full">
      <div className="flex items-center justify-between mb-1">
        <span
          className={`pixel-font text-[9px] md:text-[10px] uppercase tracking-wider ${
            compact ? "text-white/90" : "text-white"
          }`}
        >
          {STAT_ICONS[statKey] ? `${STAT_ICONS[statKey]} ` : ""}{label}
        </span>
        <span className="vt323 text-base md:text-lg text-white tabular-nums">{v}</span>
      </div>
      <div className="stat-bar-track">
        <div
          className="stat-bar-fill"
          style={{ width: `${v}%`, background: fillColor }}
        />
        <div className="stat-bar-grid">
          {Array.from({ length: 10 }).map((_, i) => (
            <div key={i} />
          ))}
        </div>
      </div>
    </div>
  );
}
